// This file is shared across the demos.

import React from 'react';
import {ListItem, ListItemIcon, ListItemText} from '@material-ui/core';

import ListIcon from '@material-ui/icons/List';
import AccessCodeIcon from '@material-ui/icons/LockOpen';

export const sideNavData = (
  <div>
    <ListItem button href={'/application/allChannels'}>
      <ListItemIcon>
        <ListIcon />
      </ListItemIcon>
      <ListItemText primary="My Channels"/>
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <AccessCodeIcon />
      </ListItemIcon>
      <ListItemText primary="More channels" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <AccessCodeIcon />
      </ListItemIcon>
      <ListItemText primary="Reports" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <AccessCodeIcon />
      </ListItemIcon>
      <ListItemText primary="My takeaways" />
    </ListItem>
  </div>
);


// WEBPACK FOOTER //
// ./src/components/Drawer/tileData.js